const fontSizes = [10, 12, 14, 16, 18, 24, 30, 36]

export default fontSizes



// WEBPACK FOOTER //
// ./src/constants/toolbarEditorOptions/fontSizes.js